













import { Component, Vue, Prop } from 'vue-property-decorator';
import { ITbasList } from '../../common/models/index-app';

@Component({
  components: {
  }
})
export default class Segment extends Vue {
  @Prop() private readonly tabsList!: ITbasList[];
  @Prop() private readonly segmentItem!: any;

  private handleChange(item: any) {
    this.$emit('change', item);
  }

}
